module.exports = `${require.publicPath}105.ad23b02f.png`;